'use strict';

var _objectSpread = require("/app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var RateLimiter = require('./rate_limiter');

var Sampler = require('./sampler');

var ext = require('../../../ext');

var setSamplingRules = require('./platform').startupLog.setSamplingRules;

var _require = require('./constants'),
    SAMPLING_RULE_DECISION = _require.SAMPLING_RULE_DECISION,
    SAMPLING_LIMIT_DECISION = _require.SAMPLING_LIMIT_DECISION,
    SAMPLING_AGENT_DECISION = _require.SAMPLING_AGENT_DECISION;

var SERVICE_NAME = ext.tags.SERVICE_NAME;
var SAMPLING_PRIORITY = ext.tags.SAMPLING_PRIORITY;
var MANUAL_KEEP = ext.tags.MANUAL_KEEP;
var MANUAL_DROP = ext.tags.MANUAL_DROP;
var USER_REJECT = ext.priority.USER_REJECT;
var AUTO_REJECT = ext.priority.AUTO_REJECT;
var AUTO_KEEP = ext.priority.AUTO_KEEP;
var USER_KEEP = ext.priority.USER_KEEP;
var DEFAULT_KEY = 'service:,env:';

var PrioritySampler =
/*#__PURE__*/
function () {
  function PrioritySampler(env) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        sampleRate = _ref.sampleRate,
        _ref$rateLimit = _ref.rateLimit,
        rateLimit = _ref$rateLimit === void 0 ? 100 : _ref$rateLimit,
        _ref$rules = _ref.rules,
        rules = _ref$rules === void 0 ? [] : _ref$rules;

    _classCallCheck(this, PrioritySampler);

    this._env = env;
    this._rules = this._normalizeRules(rules, sampleRate);
    this._limiter = new RateLimiter(rateLimit);
    setSamplingRules(this._rules);
    this.update({});
  }

  _createClass(PrioritySampler, [{
    key: "isSampled",
    value: function isSampled(span) {
      var context = this._getContext(span);

      var rule = this._findRule(context);

      return rule ? this._isSampledByRule(context, rule) && this._isSampledByRateLimit(context) : this._isSampledByAgent(context);
    }
  }, {
    key: "sample",
    value: function sample(span) {
      if (!span) return;

      var context = this._getContext(span);

      if (context._sampling.priority !== undefined) return;

      var tag = this._getPriority(context._tags);

      if (this.validate(tag)) {
        context._sampling.priority = tag;
        return;
      }

      context._sampling.priority = this.isSampled(span) ? AUTO_KEEP : AUTO_REJECT;
    }
  }, {
    key: "update",
    value: function update(rates) {
      var samplers = {};

      for (var key in rates) {
        var rate = rates[key];
        var sampler = new Sampler(rate);
        samplers[key] = sampler;
      }

      samplers[DEFAULT_KEY] = samplers[DEFAULT_KEY] || new Sampler(AUTO_KEEP);
      this._samplers = samplers;
    }
  }, {
    key: "validate",
    value: function validate(samplingPriority) {
      switch (samplingPriority) {
        case USER_REJECT:
        case USER_KEEP:
        case AUTO_REJECT:
        case AUTO_KEEP:
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "_getContext",
    value: function _getContext(span) {
      return typeof span.context === 'function' ? span.context() : span;
    }
  }, {
    key: "_getPriority",
    value: function _getPriority(tags) {
      if (tags.hasOwnProperty(MANUAL_KEEP) && tags[MANUAL_KEEP] !== false) {
        return USER_KEEP;
      } else if (tags.hasOwnProperty(MANUAL_DROP) && tags[MANUAL_DROP] !== false) {
        return USER_REJECT;
      } else {
        var priority = parseInt(tags[SAMPLING_PRIORITY], 10);

        if (priority === 1 || priority === 2) {
          return USER_KEEP;
        } else if (priority === 0 || priority === -1) {
          return USER_REJECT;
        }
      }
    }
  }, {
    key: "_isSampledByRule",
    value: function _isSampledByRule(context, rule) {
      context._tags[SAMPLING_RULE_DECISION] = rule.sampleRate;
      return rule.sampler.isSampled(context);
    }
  }, {
    key: "_isSampledByRateLimit",
    value: function _isSampledByRateLimit(context) {
      var allowed = this._limiter.isAllowed();

      context._tags[SAMPLING_LIMIT_DECISION] = this._limiter.effectiveRate();
      return allowed;
    }
  }, {
    key: "_isSampledByAgent",
    value: function _isSampledByAgent(context) {
      var key = "service:".concat(context._tags[SERVICE_NAME], ",env:").concat(this._env);
      var sampler = this._samplers[key] || this._samplers[DEFAULT_KEY];
      context._tags[SAMPLING_AGENT_DECISION] = sampler.rate();
      return sampler.isSampled(context);
    }
  }, {
    key: "_normalizeRules",
    value: function _normalizeRules(rules, sampleRate) {
      return rules.concat({
        sampleRate: sampleRate
      }).map(function (rule) {
        return _objectSpread({}, rule, {
          sampleRate: parseFloat(rule.sampleRate)
        });
      }).filter(function (rule) {
        return !isNaN(rule.sampleRate);
      }).map(function (rule) {
        return _objectSpread({}, rule, {
          sampler: new Sampler(rule.sampleRate)
        });
      });
    }
  }, {
    key: "_findRule",
    value: function _findRule(context) {
      for (var i = 0, l = this._rules.length; i < l; i++) {
        if (this._matchRule(context, this._rules[i])) return this._rules[i];
      }
    }
  }, {
    key: "_matchRule",
    value: function _matchRule(context, rule) {
      var name = context._name;
      var service = context._tags['service.name'];
      if (rule.name instanceof RegExp && !rule.name.test(name)) return false;
      if (rule.name && rule.name !== name) return false;
      if (rule.service instanceof RegExp && !rule.service.test(service)) return false;
      if (rule.service && rule.service !== service) return false;
      return true;
    }
  }]);

  return PrioritySampler;
}();

module.exports = PrioritySampler;